import { gql, TypedDocumentNode } from '@apollo/client';

import {
  MediaBulkMoveInput,
  MediaFolder,
  MediaFolderCreateInput,
  MediaFolderMoveInput,
  MediaFoldersInput,
  MediaFolderTree,
  MediaFolderUpdateInput,
} from '@atom/types/media';

export const BASE_MEDIA_FOLDER = gql`
  fragment BaseMediaFolder on MediaFolder {
    id
    name
    subjectId
    parentFolderId
    ancestors
    createdDate
    createdBy {
      firstName
      lastName
    }
    updatedDate
    updatedBy {
      firstName
      lastName
    }
  }
`;

export const GET_MEDIA_FOLDERS: TypedDocumentNode<
  { mediaFolders: MediaFolder[] },
  { input: MediaFoldersInput }
> = gql`
  query mediaFolders($input: MediaFoldersInput!) {
    mediaFolders(input: $input) {
      ...BaseMediaFolder
    }
  }
  ${BASE_MEDIA_FOLDER}
`;

export const GET_MEDIA_FOLDER_TREE: TypedDocumentNode<
  { mediaFolderTree: MediaFolderTree },
  { subjectId: string }
> = gql`
  query mediaFolderTree($subjectId: ID!) {
    mediaFolderTree(subjectId: $subjectId) {
      id
      name
      children
    }
  }
`;

export const MEDIA_FOLDER_CREATE: TypedDocumentNode<
  { mediaFolderCreate: MediaFolder },
  { input: MediaFolderCreateInput }
> = gql`
  mutation mediaFolderCreate($input: MediaFolderCreateInput!) {
    mediaFolderCreate(input: $input) {
      ...BaseMediaFolder
    }
  }
  ${BASE_MEDIA_FOLDER}
`;

export const MEDIA_FOLDER_UPDATE: TypedDocumentNode<
  { mediaFolderUpdate: MediaFolder },
  { input: MediaFolderUpdateInput }
> = gql`
  mutation mediaFolderUpdate($input: MediaFolderUpdateInput!) {
    mediaFolderUpdate(input: $input) {
      ...BaseMediaFolder
    }
  }
  ${BASE_MEDIA_FOLDER}
`;

export const MEDIA_FOLDER_DELETE: TypedDocumentNode<
  { mediaFolderDelete: boolean },
  { id: string }
> = gql`
  mutation mediaFolderDelete($id: ID!) {
    mediaFolderDelete(id: $id)
  }
`;

export const MEDIA_FOLDER_MOVE: TypedDocumentNode<
  { mediaFolderMove: boolean },
  { input: MediaFolderMoveInput }
> = gql`
  mutation mediaFolderMove($input: MediaFolderMoveInput!) {
    mediaFolderMove(input: $input)
  }
`;

export const MEDIA_BULK_MOVE: TypedDocumentNode<
  { mediaBulkMove: boolean },
  { input: MediaBulkMoveInput }
> = gql`
  mutation mediaBulkMove($input: MediaBulkMoveInput!) {
    mediaBulkMove(input: $input)
  }
`;
